import jsonp from "jsonp";
import axios from "axios";
import Rsa from "./Rsa";
export const PASSPORT_HOST = "//passport.gm99.com/";
export const STORE_HOST = "//mstore.gm99.com/";
export const GMMOBILE_HOST = "//m.gm99.com/";
export const PLATFORM_HOST = "";
export const ACHIEVEMENT_ID = 9999;
export const APP_ID = 2377606282463331;
export const CURRENCY = "TWD";
const SUCCESS_RESULT_CODE = 1;

let rsa = new Rsa();

export let convertParamToString = function(params) {
  var str = "?";
  var paramArray = [];
  for (var key in params) {
    var param = key + "=" + params[key];
    paramArray.push(param);
  }
  paramArray.push("callback");
  if (paramArray.length > 0) {
    return paramArray.join("&");
  }
  return "";
};

export let post = function(action, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(action, params)
      .then(function(response) {
        var res = response.data;
        if (SUCCESS_RESULT_CODE != res.result) {
          var errmsg =
            (res && res.msg && res.msg.replace(/\[\-\d*\]/, "")) || "";
          resolve({
            errmsg: errmsg,
            data: [],
            res: response
          });
        } else {
          resolve({
            errmsg: "",
            data: res.data,
            res: res
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  });
};

export let getJSON = function(action, params) {
  return new Promise((resolve, reject) => {
    var paramStr = convertParamToString(params || {});
    jsonp(
      action,
      {
        prefix: "jsonpCallback",
        param: paramStr
      },
      (err, response) => {
        if (err || SUCCESS_RESULT_CODE != response.result) {
          var errmsg =
            response && response.msg && response.msg.replace(/\[\-\d*\]/, "");
          resolve({
            errmsg: errmsg,
            data: [],
            res: response
          });
        } else {
          resolve({
            errmsg: "",
            data: response.data,
            res: response
          });
        }
      }
    );
  });
};

export let get = function(action, params) {
  return new Promise(resolve => {
    axios
      .get(action, {
        params
      })
      .then(function(response) {
        resolve(response);
      })
      .catch(e => {
        console.log(e);
      });
  });
};

export let getHrefParam = function(paramName, newHref) {
  var href = newHref || window.location.search.substr(1);
  var reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)");
  var matchResult = href.match(reg);
  var param = matchResult ? decodeURI(matchResult[2]) : "";
  return param;
};

export const loadConverstData = function(loadData, map) {
  var result = {};
  for (let key in map) {
    let mapKey = map[key];
    let val = loadData[mapKey] || "";
    result[key] = val;
  }
  return result;
};

export const encryption = function(text) {
  //todo encryption the text
  return rsa.encode(text);
};

export let getGameId = function() {
  return getHrefParam("game_id") || getHrefParam("gameid");
};
export let getFbParam = function(config) {
  var action = "//m.gm99.com/h5/page/get_share_content";
  return getShareContent(config, action);
};

export let getLineParam = function(config) {
  var action = "//m.gm99.com/h5/page/get_line_content";
  return getShareContent(config, action);
};

export let getShareContent = function(config, action) {
  return new Promise((resolve, reject) => {
    post(action, {
      achievementId: config.achievementId,
      appId: APP_ID,
      gameId: getGameId(),
      serverId: config.serverId,
      fbid: config.fbid || "",
      loginAccount: config.name,
      timestamp: new Date().getTime(),
      roleId: config.roleId,
      roleName: config.roleName,
      devicePlate: "pc",
      pic: ""
    }).then(({ errmsg, data }) => {
      if (errmsg) {
        resolve({
          errmsg: errmsg
        });
      } else {
        resolve({
          title: data.TITLE || "",
          description: data.DESCRIPTION || "",
          img: data.THUMB || "",
          link: data.LINK,
          token: data.TOKEN,
          errmsg: ""
        });
      }
    });
  });
};

export let getAllParamsFromHref = function(isAdd) {
  let res = window.location.search;
  return res.length > 0 ? (isAdd ? "&" + res.substr(1) : res.substr(1)) : "";
};

export const getHrefParamObj = function() {
  let paramsStr =
    window.location.search.substr(1) ||
    window.location.hash
      .replace(/^#\/\??/, "")
      .replace(/(\?)|(%3F)/g, "&")
      .replace(/%3D/g, "=");
  let res = {};
  let paramsArr = [];
  if (paramsStr.indexOf("&") >= 0) {
    paramsArr = paramsStr.split("&");
  } else if (paramsStr) {
    paramsArr = [paramsStr];
  }

  paramsArr.map(item => {
    let result = item.split("=");
    res[result[0]] = result[1];
  });

  return res;
};



// WEBPACK FOOTER //
// ./src/store/ultile.js